<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金赎回，由index.js 配置引入
-->
<template>
    <div class="bizcomp-sell-fund">
        <div class="bor_E4E4E4">
            <comp-title :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home' }">我的资产</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title>
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="基金名称：" class="form-text">
                    <div class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="fund.sharetype !== '0'"
                    label="申购费收取方式："
                    prop="sharetype"
                    class="form-text"
                >
                    <el-select v-model="fundInfo.sharetype" :disabled="fund.sharetype !== '2'">
                        <el-option value="0" label="前收费"></el-option>
                        <el-option value="1" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前收费是在申购基金时收取申购费,
                            <br />
                            而后收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="赎回到：" prop="sellTo" class="payway-list">
                    <div class="flex lin20">
                        <div
                            v-if="
                                $util.xjbIsOpen() &&
                                $util.sellToXjbOpen() &&
                                hasxjb &&
                                xjbfundcode !== fund.fundcode &&
                                !mrfflag &&
                                xjbSellflag
                            "
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 mr20 relative pointer"
                            v-on:click="fundInfo.sellTo = '1'"
                        >
                            <div class="fs18 c_333 mb10 center">
                                {{ $const.getXJBParam("name") }}
                            </div>
                            <div class="c_999 fs14">
                                最新七日年化收益率:{{ formatCurrencyAnnualRate(growthrate) }}。
                            </div>
                            <div class="c_999 fs14">买基金立享优惠</div>
                            <img
                                src="../../assets/img/recommend.png"
                                class="absolute w65 h65 _t2 _r2"
                            />
                            <div
                                v-if="fundInfo.sellTo === '1'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                        <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 relative pointer"
                            style="min-width: 120px"
                            v-on:click="fundInfo.sellTo = '2'"
                        >
                            <div class="fs18 c_333 mb10 center">银行卡</div>
                            <div
                                v-if="$util.getFundTrans('showselltobankcarddesc')"
                                class="c_999 fs14"
                            >
                                银行活期存款利率：0.35%。
                            </div>
                            <div
                                v-if="$util.getFundTrans('showselltobankcarddesc')"
                                class="c_999 fs14"
                            >
                                若不急需现金，建议转至{{ $const.getXJBParam("sname") }}
                            </div>
                            <div
                                v-if="fundInfo.sellTo === '2'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="回款账号：" prop="id" class="payway-list">
                    <el-radio-group v-model="fundInfo.id" class="bank-radio">
                        <el-radio
                            v-for="bank in fundInfo.sellTo == '1'
                                ? xjbRedeemAccountList
                                : bankRedeemAccountList"
                            :key="bank.transactionaccountid + bank.index"
                            :label="bank.transactionaccountid + bank.index"
                            border
                        >
                            <div class="bank-img-sel">
                                <img
                                    v-if="bank.bankcode"
                                    :src="$util.getImg(bank.bankcode)"
                                    alt=""
                                />
                                <div class="k-text-flow">
                                    <span
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{ bank.channelDisplayText }}
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{
                                            $util.fmtNum(
                                                Number(bank.usableremainshare) +
                                                    Number(bank.freezeremainshare)
                                            )
                                        }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                    <div v-if="sourceflagAllotment" class="sourceflag-tip">
                        <span class="allotment">
                            存在不可赎回的代销渠道份额共{{ $util.fmtNum(sourceflagAllotment) }}份。
                        </span>
                        <span class="toDetails" v-on:click.stop="showDetail">点击查看详情>>></span>
                    </div>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div class="text-con">
                        {{ $util.fmtNum(bankInfo.usableremainshare) + "份" }}
                        <span class="freeze">
                            (冻结份额：{{ $util.fmtNum(bankInfo.freezeremainshare) }}份)
                        </span>
                        <el-tooltip
                            v-if="Object.hasOwn(bankInfo, 'stopprofitfreezeremainshare')"
                            placement="top"
                        >
                            <div slot="content">
                                该基金有 {{ $util.fmtNum(bankInfo.stopprofitfreezeremainshare) }}份
                                份额因止盈定投计划被冻结，暂不可赎回。
                                <br />
                                请等待定投自动止盈，或手动终止定投协议。
                            </div>
                            <i class="el-icon-question el-icon-question-diy"></i>
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item
                    label="赎回份额："
                    prop="amount"
                    :class="{ 'form-text': !isPwdCheck && fundInfo.sellTo === '1' }"
                >
                    <amount-input v-model="fundInfo.amount" :placeholder="pla" prefix-icon="" />
                    <div class="redemp-btn-box">
                        <span
                            class="ratio-chip"
                            :class="{ active: selectedFractionOption === 4 }"
                            v-on:click.prevent="fractionSell(4)"
                        >
                            1/4
                        </span>
                        <span
                            class="ratio-chip"
                            :class="{ active: selectedFractionOption === 3 }"
                            v-on:click.prevent="fractionSell(3)"
                        >
                            1/3
                        </span>
                        <span
                            class="ratio-chip"
                            :class="{ active: selectedFractionOption === 2 }"
                            v-on:click.prevent="fractionSell(2)"
                        >
                            1/2
                        </span>
                        <span
                            class="ratio-chip"
                            :class="{ active: selectedFractionOption === 'all' }"
                            v-on:click.prevent="allSell"
                        >
                            全部赎回
                        </span>
                    </div>
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <el-form-item v-if="fund.fundtype !== '2'" label="巨额赎回处理：">
                    <el-select
                        v-model="fundInfo.largeredemptionflag"
                        :disabled="fundInfo.sellTo === '1'"
                    >
                        <el-option label="放弃超额部分" value="0" />
                        <el-option label="继续赎回" value="1" />
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。
                            <br />
                            如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回。
                            <br />
                            如果选择“放弃超额部分”则放弃赎回剩余部分。
                            <br />
                            如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.sellTo === '2' &&
                        redeemInfo.selltype &&
                        redeemInfo.selltype.indexOf('1') > -1
                    "
                    label="赎回方式："
                    prop="sell"
                    class="payway-list"
                >
                    <el-radio-group v-model="fundInfo.sell">
                        <el-radio label="0" name="sell">普通赎回</el-radio>
                        <el-radio label="1" name="sell">
                            快速赎回
                            <span>(预计2小时到账，不享受当天收益)</span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item
                    v-show="
                        (feeGate.executionrate || feeGate.executionrate === 0) &&
                        fund.fundshowtype !== '5'
                    "
                    label="赎回费率："
                    class="form-text"
                >
                    <div v-if="rateMax && rateMin">
                        <span>{{ rateMin + "~" + rateMax }}</span>
                        <img
                            v-if="fundFeeRate.length > 0 && fundFeeRate[0].feepolicy == '2'"
                            src="../../assets/img/tip-gray.png"
                            class="w18 h18"
                            style="vertical-align: middle; cursor: pointer"
                            v-on:click="
                                () => {
                                    feeRateVisible = true;
                                }
                            "
                        />
                        <span
                            v-if="
                                isPenaltyRateOpen &&
                                hasPenaltyRateHoldingShare &&
                                fundFeeRate[0].feepolicy == '2'
                            "
                            class="text-gray"
                        >
                            （若持有时间小于{{
                                penaltyRateTipData.punitiveratedays
                            }}日，将收取不低于{{
                                penaltyRateTipData.punitiveRateText || "1.50%"
                            }}的赎回手续费）
                        </span>
                    </div>
                    <div v-else>
                        {{ $util.fmtToPercent(feeGate.executionrate) }}
                    </div>
                </el-form-item>
                <el-form-item
                    v-show="
                        fund.fundshowtype !== '5' &&
                        (feeGate.estimatedcost || feeGate.estimatedcost === 0)
                    "
                    label="预估赎回手续费："
                    class="form-text"
                >
                    <div>
                        <span style="color: var(--color-primary)">
                            {{ $util.fmtNum(feeGate.estimatedcost) }}元
                        </span>
                        <span class="text-gray left-5">(仅为预计金额，以基金公司确认为准)</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="$util.hasFM(fund)">
                    <div>
                        <span style="color: var(--color-primary)">
                            该产品为浮动管理费产品，存在扣除超额管理费或返还或有管理费的可能，具体金额以实际到账为准。您可通过交易确认查询。
                        </span>
                    </div>
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <!--                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>-->
                </el-form-item>
                <el-form-item v-if="hasShowProtocol" style="margin-left: -80px">
                    <div class="protocol-checkbox-group">
                        <div class="protocol-checkbox-label">
                            <input v-model="checkbox" type="checkbox" />
                            <span>我已阅读并同意:</span>
                        </div>
                        <div v-if="sellShow || sellToShow" class="protocol-file-list">
                            <ul v-if="sellShow">
                                <li v-for="(item, index) in protocolArr" :key="index">
                                    <a
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick2(index, '0')"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                </li>
                            </ul>
                            <ul v-if="sellToShow">
                                <li v-for="(item, index) in xjbReadFileLists" :key="'read' + index">
                                    <a
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick1(index)"
                                    >
                                        《{{ item.filename }}》
                                    </a>
                                </li>
                                <li v-for="(item, index) in xjbFundFiles" :key="'xjb' + index">
                                    <a
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick2(index, '1')"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-form-item>
                <!-- <el-form-item
                    v-if="$util.getFundTrans('showpenaltyrate') && fund.fundshowtype !== '5'"
                >
                    <div>
                        <span class="c_E60012">
                            基金赎回会产生一定费用，若持有时间小于7日，将收取1.5%的赎回手续费。
                        </span>
                        <a v-if="linkUrl" target="_blank" :href="linkUrl">点击查看费率>>></a>
                    </div>
                </el-form-item> -->
                <el-form-item
                    v-if="(fundInfo.sellTo == '1' && tradeRestrictionsShow) || postChargeDescribe"
                >
                    <div
                        class="deadlinetime-content"
                        style="color: var(--color-text-accent); line-height: 20px"
                    >
                        <div>温馨提示：</div>
                        <div
                            v-if="fundInfo.sellTo == '1' && tradeRestrictionsShow"
                            style="display: flex; align-items: flex-start"
                        >
                            <span style="margin-right: 2px">1.</span>
                            <span class="c_E60012">
                                {{ $cache.getCompanyInfoParam("10102035") }}
                            </span>
                        </div>
                        <div
                            v-if="postChargeDescribe"
                            class="add-c_E60012"
                            style="display: flex; align-items: flex-start"
                        >
                            <span style="margin-right: 2px">
                                {{ fundInfo.sellTo == "1" && tradeRestrictionsShow ? "2." : "1." }}
                            </span>
                            <span>{{ postChargeDescribe }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%">
                        <el-button class="medium bc_E4E4E4 c_666666" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="fundInfo.sell == '1' && !checkbox"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="goToTradeRecord"
                v-on:return-login="$router.push({ name: 'home' })"
            >
                <template v-if="result.sellToText" slot="extra-info">
                    <div class="sell-to-info">到账方式：{{ result.sellToText }}</div>
                </template>
            </result>
            <fund-protocol
                v-model="protocol"
                :fund="xjbFundRisk"
                :show-proto-arr="false"
                v-on:all-read="sellFund"
            />
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
        ></footerQuestions>
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
        <my-dialog
            class="my-dialog-contain"
            title="费率"
            :visible="feeRateVisible"
            width="550px"
            :dialog-close="
                () => {
                    feeRateVisible = false;
                }
            "
        >
            <div class="dialog-box">
                <div class="">基金赎回手续费将按持有天数对应费率计算：</div>
                <el-table :data="fundFeeRate" class="rate-table" border>
                    <el-table-column prop="interval" label="持有期限" align="center" />
                    <el-table-column prop="feerate" label="费率" align="center" />
                </el-table>
                <div class="text-desc">
                    系统遵循先进先出原则；若赎回份额覆盖不同持有期限，将按分段费率分别计算后汇总。
                </div>
                <div style="text-align: center">
                    <el-button
                        class="btn"
                        v-on:click="
                            () => {
                                feeRateVisible = false;
                            }
                        "
                    >
                        确定
                    </el-button>
                </div>
            </div>
        </my-dialog>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="needTime"
            :read-file-info-list="currentFileInfoList"
            :show-close="true"
            v-on:close="finishReading"
            v-on:cancel="cancelReading"
        ></pdf-popup>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import format from "date-fns/format";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";
import commonApi from "@/api/common";
import myDialog from "@/components/layout/myDialog.vue";

import { sceneEnum } from "@/util/util_jfit";
import PdfPopup from "@/components/util/pdfPopup.vue";
import AmountInput from "@/components/common/AmountInput.vue";
export default {
    name: "SellFund",
    components: {
        PdfPopup,
        result,
        fundProtocol,
        footerQuestions,
        buyRiskDialog,
        myDialog,
        AmountInput
    },
    mixins: [mixin],
    data() {
        return {
            fundInfo: {
                amount: "",
                id: "",
                sell: "0",
                sharetype: "",
                sellTo: "",
                pwd: "",
                largeredemptionflag: "1"
            },
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            selectedFractionOption: null,
            pla: "请先选择回款账号",
            fund: {}, // 基金信息获取
            sellLimit: {},
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的基金赎回申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            bankLists: [],
            xjbFundRisk: {}, // 现金宝适当性信息检查
            query: null,
            rules: {
                amount: [{ validator: this.amountLimit, trigger: "change" }],
                id: [{ required: true, message: "请选择回款账号", trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "change" }],
                largeredemptionflag: [
                    { required: true, message: "请选择巨额赎回处理方式", trigger: "change" }
                ],
                sharetype: [{ required: true, message: "请选择收费方式", trigger: "change" }]
            },
            limit: { min: "0.01", max: "0", text: "赎回份额范围为：" },
            bankInfo: {},
            feeGate: {}, // 根据赎回份额查询的费率和费用信息
            fundFeeRate: [], // 根据基金代码查询赎回费率列表
            rateMax: "", // 最大费率值
            rateMin: "", // 最小费率值
            feeRateVisible: false, // 赎回费率展示
            hover: false,
            redeemInfo: {}, // 产品限额
            fastRedeemData: {}, // 快赎限额
            commonQuestion: [],
            xjbfundcode: "",
            xjbFundInfo: {},
            growthrate: "", // 现金宝1七日年化
            hasxjb: false, // 是否可以赎回到钱柜
            isOffline: false,
            mrfflag: false, // 是否中港互认
            linkUrl: "",
            tradeRestrictionsShow: false, // 节假日xx宝的提示
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            protocolArr: [],
            sellFiles: [],
            quickSellFiles: [],
            xjbReadFileLists: [],
            xjbFundFiles: [],
            checkbox: false, // 阅读确认
            agrType: "B", // 协议类型 快赎
            postChargeDescribe: "", // 附加管理费说明
            sourceflagAllotment: "", // 代销总份额
            xjbSellflag: true, // 有赎回到现金宝的账号
            xjbRedeemBusinessCode: "099",
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            sellFeeQuerySeq: 0,
            xjbConvertRelationCache: {},
            xjbConvertRelationPending: {},
            penaltyRateData: null,
            penaltyRateTipData: null,
            penaltyRateQuerySeq: 0,
            penaltyRateConfirmKey: "",
            offlineRedeemAccountAlertShown: false // 线下渠道过滤提示只展示一次，避免初始化联动重复弹窗
        };
    },
    computed: {
        sellShow() {
            // 赎回到银行卡或现金宝都展示协议
            return this.protocolArr.length > 0;
        },
        sellToShow() {
            return (
                this.fundInfo.sellTo === "1" &&
                (this.xjbReadFileLists.length > 0 || this.xjbFundFiles.length > 0)
            );
        },
        hasShowProtocol() {
            return this.sellShow || this.sellToShow;
        },
        // 银行卡赎回账号列表：线下渠道(banktype=1)按当前赎回方式校验对应业务码
        bankRedeemAccountList() {
            return (this.fund.fundArr || []).filter((item) => this.isBankRedeemAccount(item));
        },
        xjbRedeemAccountList() {
            return (this.fund.fundArr || []).filter((item) => this.isXjbRedeemAccount(item));
        },
        isPenaltyRateOpen() {
            if (this.fund.fundtype === "04") {
                return false;
            }
            const oemList = this.$cache.getCompanyInfoParam("10301003") || "";
            return oemList.indexOf("A72") !== -1;
        },
        hasPenaltyRateHoldingShare() {
            return (
                this.isPenaltyRateOpen &&
                Number(this.penaltyRateTipData && this.penaltyRateTipData.rangeholdvol) > 0
            );
        }
    },
    watch: {
        isOffline(val) {
            if (val && this.fundInfo.sellTo === "1" && !this.isXjbRedeemAccount(this.bankInfo)) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
        },
        "fundInfo.id"(val) {
            const account = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            if (!account) {
                this.clearRedeemAccountState();
                return;
            }
            this.bankInfo = account;
            this.isOffline = this.isOfflineAccount(this.bankInfo);
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
            this.queryFundlimit();
        },
        /* 赎回类型   0-普通赎回 1-快速赎回 */
        "fundInfo.sell"(val) {
            if (val === "1") {
                this.isPwdCheck = this.$cache.getPwdCheck("98");
                this.$set(this.fundInfo, "sellTo", "2");
                this.protocolArr = this.quickSellFiles;
                this.checkbox = false;
                const shouldWarnMissingQuickAgreement = this.protocolArr.length === 0;

                const arr = this.bankRedeemAccountList;
                if (arr.length === 0) {
                    this.$set(this.fundInfo, "sell", "0");
                    return;
                }
                if (!this.isBankRedeemAccount(this.bankInfo)) {
                    this.$set(this.fundInfo, "id", arr[0].transactionaccountid + arr[0].index);
                    if (shouldWarnMissingQuickAgreement) {
                        this.showQuickSellAgreementMissingMessage();
                    }
                    return;
                }
            } else {
                this.protocolArr = this.sellFiles;
                this.isPwdCheck = this.$cache.getPwdCheck("24");
                this.checkbox = false;
            }
            this.queryFundlimit();
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
            }
            if (val === "1" && this.protocolArr.length == 0) {
                this.$message.error(
                    `缺失快速赎回协议，请联系【${this.$cache.getCompanyInfoParam("10101009")}】`
                );
            }
        },
        "fundInfo.sharetype"(val) {
            if (val === "1") {
                this.feeGate = {};
            }
        },
        "fundInfo.sellTo"(val) {
            if (val === "") {
                this.$set(this.fundInfo, "id", "");
                return;
            }
            if (val === "1") {
                // 钱柜只支持普通赎回
                this.$set(this.fundInfo, "sell", "0");
                this.$set(this.fundInfo, "largeredemptionflag", "0");
                this.checkXjbRiskLevel();
                // 处理赎回到现金宝选中第一条
                const arr = this.xjbRedeemAccountList;
                if (arr.length > 0) {
                    this.$set(this.fundInfo, "id", arr[0].transactionaccountid + arr[0].index);
                } else {
                    this.$set(
                        this.fundInfo,
                        "sellTo",
                        this.bankRedeemAccountList.length > 0 ? "2" : ""
                    );
                    return;
                }
            } else if (val === "2") {
                // 切回银行卡时，也基于过滤后的可见账号列表回填默认值
                const arr = this.bankRedeemAccountList;
                if (arr.length > 0) {
                    this.$set(this.fundInfo, "id", arr[0].transactionaccountid + arr[0].index);
                } else if (this.canUseXjbRedeem()) {
                    this.$set(this.fundInfo, "sellTo", "1");
                    return;
                } else {
                    this.$set(this.fundInfo, "sellTo", "");
                    return;
                }
            } else {
                this.$set(this.fundInfo, "id", "");
                return;
            }
            if (!this.hasSelectedRedeemAccount()) {
                return;
            }
            this.getLimit();
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        }
    },
    async mounted() {
        this.commonQuestion = this.$const.commonQuestion.commonQuestion10;
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        // 预约赎回时修改标题
        if (this.fund && this.fund.redeemflag == "0") {
            this.title = "预约赎回";
        }
        const urlTemplate = this.$cache.getCompanyInfoParam("10102041");
        // eslint-disable-next-line no-template-curly-in-string
        this.linkUrl = urlTemplate.replaceAll("${fundcode}", this.fund.fundcode);
        if (this.fund && this.fund.fundArr && this.fund.fundArr.length > 0) {
            this.calculateTotal();
            this.fund.fundArr = this.fund.fundArr.filter((item) => {
                // sourceflag 为空字符串时，视为直销（兼容现金宝持仓数据不带 sourceflag 的情况）
                return (
                    (item.sourceflag === "1" || item.sourceflag === "") &&
                    item.usableremainshare > 0
                );
            });
            // 预处理渠道数据
            this.fund.fundArr.forEach((item) => {
                this.$util.preprocessChannelData(item);
            });
            // 当没有符合赎回现金宝的账号 此选项直接隐藏
            let arr = this.xjbRedeemAccountList;
            if (arr.length) {
                this.xjbSellflag = true;
            } else {
                this.xjbSellflag = false;
                // 没有现金宝账号时，根据参数10113007决定是否默认选银行卡
                const redeemToDefault = this.$cache.getCompanyInfoParam("10113007") || "1";
                this.$set(this.fundInfo, "sellTo", redeemToDefault === "3" ? "" : "2");
            }

            // let fundArr = Object.assign([], this.fund.fundArr);
            // let zx = [];
            // this.fund.fundArr = this.fund.fundArr.filter(
            //     (fund) =>
            //         fund.paycenterid !== this.$util.getConfig().const.ZX_CENTER &&
            //         fund.paycenterid !== "0001"
            // );
            // zx = fundArr.filter(
            //     (fund) =>
            //         fund.paycenterid === this.$util.getConfig().const.ZX_CENTER ||
            //         fund.paycenterid === "0001"
            // );
            // zx.forEach((item) => this.fund.fundArr.push(item));
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        // 根据参数10113007先设置默认到账方式，cfgFundrealtimeQueryAll异步完成前避免空白
        {
            const redeemToDefault = this.$cache.getCompanyInfoParam("10113007") || "1";
            if (redeemToDefault !== "3") {
                this.$set(this.fundInfo, "sellTo", "2");
            }
        }
        // 查询现金宝信息
        await this.cfgFundrealtimeQueryAll();
        this.getSellInfo().then(() => {
            this.showOfflineRedeemAccountFilteredAlert();
        });
        // 查中港互认基金标识
        fundApi
            .getFundLists({
                keyword: this.fund.fundcode,
                pagesize: 20,
                pagenum: 1
            })
            .then((res) => {
                if (res.data) {
                    const list = res.data.list;
                    this.mrfflag = list.length > 0 && list[0].mrfflag === "1";
                    if (this.mrfflag) {
                        this.$nextTick(() => {
                            this.$set(this.fundInfo, "sellTo", "2");
                        });
                    }
                    if (list.length > 0 && list[0].ext) {
                        try {
                            const extData = JSON.parse(list[0].ext.replace(/\n/g, "\\n"));
                            const extraItem = extData.find(
                                (item) => item.definition === "附加管理费说明"
                            );
                            if (extraItem) {
                                this.postChargeDescribe = extraItem.content;
                            }
                        } catch (error) {
                            console.error("解析失败:", error);
                        }
                    }
                }
            });
        this.$cache.getCompanyInfoParam("10102033") &&
            this.isInTimeRange(
                this.$cache.getCompanyInfoParam("10102033"),
                format(new Date(), "YYYYMMDDhhmmss")
            );

        this.getAgreement(); // 获取快速赎回协议
        // 查询赎回费率信息
        this.getFundFeeRate();
        this.getXjbFileInfo();
    },
    methods: {
        formatCurrencyAnnualRate(rate) {
            // 现金宝七日年化按产品口径固定展示3位小数，避免沿用历史4位展示。
            if (this.$util.isEmpty(rate)) {
                return "--";
            }
            return this.$util.fmtNum(rate, 3) + "%";
        },
        isOfflineAccount(account) {
            if (!account) return false;
            return (
                account.paycenterid === this.$util.getConfig().const.ZX_CENTER ||
                account.paycenterid === "0001"
            );
        },
        isOfflineBanktypeAccount(account) {
            return account && account.banktype === "1";
        },
        // 参数26051901控制线下渠道是否允许办理指定业务码
        canRedeemOfflineByBusinessCode(code) {
            const offlineBusinessCodes = this.$cache.getSysParam("26051901") || "";
            return offlineBusinessCodes.indexOf(code) !== -1;
        },
        getBankRedeemBusinessCode() {
            return this.fundInfo.sell === "1" ? "098" : "024";
        },
        getXjbRedeemBusinessCode() {
            return this.xjbRedeemBusinessCode || "099";
        },
        async refreshXjbRedeemBusinessCode() {
            try {
                const hasRelation = await this.hasXjbConvertRelation();
                this.xjbRedeemBusinessCode = hasRelation ? "036" : "099";
            } catch (e) {
                console.error("查询现金宝转换关系失败", e);
                this.xjbRedeemBusinessCode = "099";
            }
        },
        // 银行卡赎回：线下渠道需额外校验当前赎回方式对应的业务码
        isBankRedeemAccount(account) {
            return (
                account &&
                (!this.isOfflineBanktypeAccount(account) ||
                    this.canRedeemOfflineByBusinessCode(this.getBankRedeemBusinessCode()))
            );
        },
        // 赎回到现金宝：有转换关系走036，无转换关系走099
        isXjbRedeemAccount(account) {
            return (
                account &&
                account.sellmode &&
                account.sellmode.includes("1") &&
                account.redeemflag !== "0" &&
                (!this.isOfflineBanktypeAccount(account) ||
                    this.canRedeemOfflineByBusinessCode(this.getXjbRedeemBusinessCode()))
            );
        },
        // 有线下渠道份额，但因26051901未开放对应业务码，被过滤到无可选回款账号
        hasOfflineRedeemAccountFilteredByBusinessCode() {
            return (this.fund.fundArr || []).some((account) => {
                if (!this.isOfflineBanktypeAccount(account)) {
                    return false;
                }
                const bankRedeemBlocked = !this.canRedeemOfflineByBusinessCode(
                    this.getBankRedeemBusinessCode()
                );
                const xjbRedeemBlocked =
                    account.sellmode &&
                    account.sellmode.includes("1") &&
                    account.redeemflag !== "0" &&
                    !this.canRedeemOfflineByBusinessCode(this.getXjbRedeemBusinessCode());

                return bankRedeemBlocked || xjbRedeemBlocked;
            });
        },
        shouldShowOfflineRedeemAccountFilteredAlert() {
            return (
                !this.offlineRedeemAccountAlertShown &&
                this.bankRedeemAccountList.length === 0 &&
                this.xjbRedeemAccountList.length === 0 &&
                this.hasOfflineRedeemAccountFilteredByBusinessCode()
            );
        },
        showOfflineRedeemAccountFilteredAlert() {
            if (!this.shouldShowOfflineRedeemAccountFilteredAlert()) {
                return;
            }
            this.offlineRedeemAccountAlertShown = true;
            this.$alert("直销柜台购买的产品需在直销柜台进行操作", "提示", {
                confirmButtonText: "确定",
                showClose: false
            })
                .then(() => {
                    this.$router.back();
                })
                .catch(() => {});
        },
        // end
        canUseXjbRedeem() {
            return (
                this.$util.xjbIsOpen() &&
                this.$util.sellToXjbOpen() &&
                this.hasxjb &&
                this.xjbfundcode !== this.fund.fundcode &&
                !this.mrfflag &&
                this.xjbSellflag &&
                this.xjbRedeemAccountList.length > 0
            );
        },
        hasSelectedRedeemAccount() {
            return !!(this.bankInfo && this.bankInfo.transactionaccountid);
        },
        clearRedeemAccountState() {
            this.bankInfo = {};
            this.isOffline = false;
            this.fastRedeemData = {};
            this.feeGate = {};
            this.clearPenaltyRate();
            this.$set(this.limit, "min", "0.01");
            this.$set(this.limit, "max", "0");
            this.pla = "请先选择回款账号";
        },
        getDefaultSellTo(redeemToDefault = this.$cache.getCompanyInfoParam("10113007") || "1") {
            const hasBankRedeemAccount = this.bankRedeemAccountList.length > 0;
            const canUseXjbRedeem = this.canUseXjbRedeem();

            if (redeemToDefault === "3") {
                return "";
            }
            if (!hasBankRedeemAccount && canUseXjbRedeem) {
                return "1";
            }
            if (redeemToDefault === "2") {
                return canUseXjbRedeem ? "1" : hasBankRedeemAccount ? "2" : "";
            }
            return hasBankRedeemAccount ? "2" : canUseXjbRedeem ? "1" : "";
        },
        resolveSellToByAvailability(
            sellTo = this.fundInfo.sellTo,
            redeemToDefault = this.$cache.getCompanyInfoParam("10113007") || "1"
        ) {
            const hasBankRedeemAccount = this.bankRedeemAccountList.length > 0;
            const canUseXjbRedeem = this.canUseXjbRedeem();

            if (sellTo === "1") {
                return canUseXjbRedeem ? "1" : hasBankRedeemAccount ? "2" : "";
            }
            if (sellTo === "2") {
                return hasBankRedeemAccount ? "2" : canUseXjbRedeem ? "1" : "";
            }
            return this.getDefaultSellTo(redeemToDefault);
        },
        // 统一从当前到账方式对应的过滤后列表中取默认账号
        getDefaultRedeemAccount(sellTo = this.fundInfo.sellTo) {
            if (sellTo !== "1" && sellTo !== "2") {
                return null;
            }
            const accountList =
                sellTo === "1" ? this.xjbRedeemAccountList : this.bankRedeemAccountList;
            return accountList.length > 0 ? accountList[0] : null;
        },
        showQuickSellAgreementMissingMessage() {
            this.$message.error(
                `缺失快速赎回协议，请联系【${this.$cache.getCompanyInfoParam("10101009")}】`
            );
        },
        async getAgreement() {
            // 判断是否为预约赎回
            const isBookingRedeem = this.fund.redeemflag === "0";

            // 如果是预约赎回，使用预约赎回场景，否则使用普通赎回场景
            const scene = isBookingRedeem ? sceneEnum.bookRedeem : sceneEnum.sell;

            const riskFileList = await this.$util.queryAgreementFile({
                scene: scene,
                fundshowtype: this.fund.showtype
            });
            this.sellFiles = riskFileList;
            this.protocolArr = this.fundInfo.sell === "1" ? this.quickSellFiles : this.sellFiles;
            this.fund.fundshowtype == "5" &&
                this.$util.getProtocol(sceneEnum.quickSell, this.fund.fundshowtype).then((res) => {
                    this.quickSellFiles = res || [];
                    if (this.fundInfo.sell === "1") {
                        this.protocolArr = this.quickSellFiles;
                        this.checkbox = false;
                        if (this.quickSellFiles.length === 0) {
                            this.showQuickSellAgreementMissingMessage();
                        }
                    }
                });
        },
        // 获取披露文件信息
        async getXjbFileInfo() {
            const isQueryXjbFile = this.$cache.getCompanyInfoParam("10105011") || "1";
            if (isQueryXjbFile === "0" || !this.xjbfundcode) {
                return;
            }
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.xjbfundcode,
                    sharetype: this.xjbFundInfo.sharetype,
                    filetype: ""
                },
                (res) => {
                    res.forEach((item) => {
                        item.read = false;
                        if (item.filetype.trim() === "7") {
                            // 产品概要
                            this.xjbReadFileLists.unshift(item);
                        } else {
                            this.xjbReadFileLists.push(item);
                        }
                    });
                    this.xjbFundInfo.proto = "xjbBuy";
                    this.$util.getSdxProtocol(this.xjbFundInfo, (res) => {
                        this.xjbFundInfo = res;
                        if (res.protoArr && res.protoArr.length > 0) {
                            res.protoArr.forEach((item) => {
                                item.filename = item.title;
                                if (item.fileid == null || !item.fileid) {
                                    item.fileid = "";
                                }
                                this.xjbFundFiles.push(item);
                            });
                        }
                    });
                }
            );
        },
        isInTimeRange(timeRange, currentTime) {
            const [start, end] = timeRange.split(",");
            this.tradeRestrictionsShow = currentTime >= start && currentTime <= end;
            return currentTime >= start && currentTime <= end;
        },
        // 获取限额
        getLimit() {
            if (!this.hasSelectedRedeemAccount()) {
                this.pla = "请先选择回款账号";
                return;
            }
            let _max = null;
            let _min = null;
            if (this.fundInfo.sell === "0") {
                // 普通赎回
                if (this.fundInfo.sellTo === "1") {
                    // 钱柜
                    _max =
                        Number(this.bankInfo.usableremainshare) > Number(this.redeemInfo.xjbmax)
                            ? this.redeemInfo.xjbmax
                            : this.bankInfo.usableremainshare;
                    _min = this.redeemInfo.xjbmin;
                } else {
                    // 银行卡
                    _max =
                        Number(this.bankInfo.usableremainshare) >
                        Number(this.fastRedeemData.maxfastredeem)
                            ? this.fastRedeemData.maxfastredeem
                            : this.bankInfo.usableremainshare;
                    _min = this.fastRedeemData.minamount;
                }
            } else {
                // 快速赎回
                _max =
                    Number(this.bankInfo.usableremainshare) >
                    Number(this.fastRedeemData.maxfastredeem)
                        ? this.fastRedeemData.maxfastredeem
                        : this.bankInfo.usableremainshare;
                _min = this.fastRedeemData.minamount;
            }
            if (this.$util.isEmpty(_max)) {
                // 没返回最大限额，最大值为可用份额
                _max = this.bankInfo.usableremainshare;
            }
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla =
                Number(_min) < Number(_max)
                    ? "本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份"
                    : "本次只可全部赎回剩余份额";
        },

        // 查询现金宝信息
        async cfgFundrealtimeQueryAll() {
            this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
            this.xjbfundcode = this.xjbFundInfo.fundcode;
            // 读取参数10113007：赎回时到账方式默认值 1-银行卡 2-现金宝 3-不选中
            const redeemToDefault = this.$cache.getCompanyInfoParam("10113007") || "1";

            if (!this.xjbfundcode || this.xjbfundcode === this.fund.fundcode) {
                // 赎回的就是现金宝本身，或没有现金宝配置，只能赎回到银行卡，强制默认选中银行卡
                this.$set(this.fundInfo, "sellTo", "2");
                return;
            }
            this.growthrate = this.xjbFundInfo.growthrate;
            // 赎回转购限额查询
            const res2 = await fundApi.combTransRedeemForBuyLimit({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                targetfundcode: this.xjbfundcode
            });
            this.hasxjb = res2.data && res2.data.datalist && res2.data.datalist.length > 0;
            await this.refreshXjbRedeemBusinessCode();
            this.xjbSellflag = this.xjbRedeemAccountList.length > 0;
            // 根据参数10113007设置默认到账方式
            // redeemToDefault: 1-银行卡, 2-现金宝, 3-不选中
            this.$set(this.fundInfo, "sellTo", this.getDefaultSellTo(redeemToDefault));
            this.redeemInfo.xjbmin =
                res2.data &&
                res2.data.datalist &&
                res2.data.datalist[0] &&
                res2.data.datalist[0].min
                    ? res2.data.datalist[0].min
                    : 0;
            this.redeemInfo.xjbmax =
                res2.data &&
                res2.data.datalist &&
                res2.data.datalist[0] &&
                res2.data.datalist[0].max
                    ? res2.data.datalist[0].max
                    : 0;
            // 兜底 当现金宝模块没开默认勾选银行卡
            if (!this.$util.xjbIsOpen()) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
            // 兜底 当赎回到现金宝功能未开通默认勾选银行卡
            if (!this.$util.sellToXjbOpen()) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
            if (this.fundInfo.sellTo === "1" && !this.isXjbRedeemAccount(this.bankInfo)) {
                const account = this.xjbRedeemAccountList[0];
                if (account) {
                    this.$set(this.fundInfo, "id", account.transactionaccountid + account.index);
                } else {
                    this.$set(
                        this.fundInfo,
                        "sellTo",
                        this.bankRedeemAccountList.length > 0 ? "2" : ""
                    );
                }
            }
        },
        async queryFundlimit() {
            if (!this.hasSelectedRedeemAccount()) {
                this.fastRedeemData = {};
                return;
            }
            let res = await fundApi.combQueryFundlimit({
                fundcode: this.fund.fundcode,
                transactionaccountid: this.bankInfo.transactionaccountid,
                bankcode: this.bankInfo.bankcode,
                sharetype: this.bankInfo.sharetype,
                businesscode: this.fundInfo.sell === "0" ? "024" : "098",
                invtp: "1",
                transflag: "1"
            });
            this.fastRedeemData = res.data || {};
            this.getLimit();
        },
        // 获取链接点击事件
        getClick1(index) {
            this.currentFileInfoList = [this.xjbReadFileLists[index]];
            this.xjbReadFileLists[index].read = true;
            this.needTime = this.xjbReadFileLists[0].filetype === "7";
            this.pdfVisible = true;
        },
        getClick2(index, type) {
            this.currentFileInfoList =
                type === "0" ? [this.protocolArr[index]] : [this.xjbFundFiles[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        finishReading() {
            this.pdfVisible = false;
        },
        cancelReading() {
            this.checkbox = false;
            this.pdfVisible = false;
        },
        checkXjbRiskLevel() {
            // 赎回到现金宝，客户风险等级为0时，进行提示拦截
            if (this.fundInfo.sellTo === "1") {
                const info = this.$cache.getUser();
                if (info.risklevel === "0") {
                    const userRiskLevel = this.$cache.getDict("100017", info.risklevel) || "";
                    this.$alert(
                        `您的风险测评结果是${userRiskLevel}，不能购买任何产品。`,
                        "风险提示",
                        {
                            confirmButtonText: "重新测评",
                            cancelButtonText: "我知道了",
                            showCancelButton: true
                        }
                    ).then(() => {
                        this.$router.push({ name: "risk" });
                    });
                    return false;
                }
            }
            return true;
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            // 校验赎回到账方式是否已选择（参数10113007=3时默认不选中）
            if (!this.fundInfo.sellTo) {
                return this.$alert("请选择赎回到账方式", "提示", { confirmButtonText: "确定" });
            }
            if (!this.checkXjbRiskLevel()) {
                return;
            }
            if (
                Number(this.bankInfo.usableremainshare) - Number(this.fundInfo.amount) <
                    Number(this.redeemInfo.minaccountbalance) &&
                Number(this.fundInfo.amount) !== Number(this.bankInfo.usableremainshare)
            ) {
                this.$alert(
                    `最低可持有份额低于${this.redeemInfo.minaccountbalance}份，建议全部卖出`,
                    "温馨提示"
                );
                return;
            }
            if (this.hasShowProtocol) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
                if (this.sellShow) {
                    commonApi.agreementLeaveTracesLog(
                        this,
                        {
                            eventid:
                                this.$const.RECORD.cms_protocol_agreement_agree +
                                "/" +
                                sceneEnum.sell,
                            eventname: `协议同意`
                        },
                        this.protocolArr
                    );
                }
                if (this.sellToShow) {
                    if (this.xjbReadFileLists.length > 0) {
                        commonApi.fundFileLeaveTracesLog(
                            this,
                            this.xjbReadFileLists,
                            this.xjbfundcode
                        );
                    }
                    if (this.xjbFundFiles.length > 0) {
                        setTimeout(() => {
                            commonApi.agreementLeaveTracesLog(
                                this,
                                {
                                    eventid:
                                        this.$const.RECORD.cms_protocol_agreement_agree +
                                        "/" +
                                        sceneEnum.xjbBuy,
                                    eventname: `协议同意`
                                },
                                this.xjbFundFiles
                            );
                        }, 0); // 确保在下一次事件循环中执行(不加settimeout短时间执行两次会被吞？)
                    }
                    // 获取留痕申请编号
                    this.$util.writeFileInfo(
                        {
                            readFileInfoList: this.readFileInfoList,
                            fundcode: this.fund.fundcode,
                            tano: this.fund.tano
                        },
                        (res) => {
                            // this.readappno = res;
                        },
                        this
                    );
                }
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.fundInfo.sellTo === "1") {
                        // TODO 赎回至现金宝 暂不支持
                        // 开了购买前校验开关才用
                        if (this.$util.buyVerificationOpen()) {
                            this.$util.checkComplianceService(this.xjbfundcode).then((checkRes) => {
                                if (checkRes.dialogType) {
                                    this.dialogButtonText = checkRes.dialogButtonText;
                                    this.dialogType = checkRes.dialogType;
                                    this.dialogContent = checkRes.dialogContent;
                                    this.buyRiskdialogVisible = true;
                                } else {
                                    this.$util.getSdxProtocol(
                                        {
                                            fundcode: this.xjbfundcode,
                                            fundshowtype: this.fund.fundshowtype,
                                            proto: "sell"
                                        },
                                        (res) => {
                                            this.xjbFundRisk = res;
                                            this.protocol = true;
                                        }
                                    );
                                }
                            });
                        } else {
                            this.$util.getSdxProtocol(
                                {
                                    fundcode: this.xjbfundcode,
                                    fundshowtype: this.fund.fundshowtype,
                                    proto: "sell"
                                },
                                (res) => {
                                    this.xjbFundRisk = res;
                                    this.protocol = true;
                                }
                            );
                        }
                    } else {
                        this.sellFund(true);
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        async sellFund(val) {
            this.protocol = false;
            if (!val) return;
            await this.queryPenaltyRate();
            const penaltyRateConfirmed = await this.confirmPenaltyRateIfNeeded();
            if (!penaltyRateConfirmed) return;
            let params = {
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                transactionaccountid: this.bankInfo.transactionaccountid,
                applicationvol: this.fundInfo.amount, // 输入框内的份额
                largeredemptionflag: this.fundInfo.largeredemptionflag, // 巨额赎回标志   字典：110051 0-放弃超额部分 1-继续赎回
                tradepassword: this.$util.enc(this.fundInfo.pwd)
            };
            if (this.fundInfo.sellTo === "1") {
                // 钱柜（赎回到现金宝）
                params = Object.assign({}, params, {
                    targetfundcode: this.xjbfundcode,
                    targetsharetype: this.xjbFundInfo.sharetype,
                    buyflag: this.xjbFundRisk.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: this.xjbFundRisk.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: this.xjbFundRisk.highriskwarnflag == "1" ? "1" : "2"
                });
                // 中港互认基金增加入参mrffundflag传1
                if (this.mrfflag) {
                    params.mrffundflag = "1";
                }
                // 高龄客户风险警示标识 1-已警示
                if (this.dialogType == "warn") {
                    params.oldercustriskflag = "1";
                }
                // 新接口不需要 largeredemptionflag 和 redeemmode，移除
                delete params.largeredemptionflag;
            } else {
                // 银行卡
                params = Object.assign({}, params, {
                    selltype: this.fundInfo.sell, // 赎回类型   0-普通赎回 1-快速赎回
                    referid: "", // 推荐人代码
                    referralname: "" // 推荐人姓名
                });
                // 如果是预约赎回，增加预约赎回日期入参
                if (this.fund.redeemflag == "0") {
                    params.enddate = this.fund.enddate;
                }
            }
            if (this.fundInfo.sell == "1") {
                this.tracesLog(this.protocolArr);
            }
            let rs = await fundApi[
                this.fundInfo.sellTo === "1" ? "combTransRedeemForXjb" : "redeemAsset"
            ](params);
            if (rs.error) return;
            const isBookingRedeem = this.fund.redeemflag == "0";
            if (rs.data) {
                this.result.cla = "register-success";
                if (this.fundInfo.sell === "0") {
                    this.result.btnMsg = `预计确认时间：${this.$util.fmtDate(
                        rs.data.transactioncfmdate
                    )}，资金预计到账时间：${this.$util.fmtDate(
                        rs.data.redeempaybackdate
                    )}，如遇节假日则顺延，请耐心等待`;
                } else {
                    this.result.btnMsg = "预计确认时间：两小时内到账，请耐心等待";
                }
                // 预约赎回时展示到账方式
                if (isBookingRedeem) {
                    const sellToText =
                        this.fundInfo.sellTo === "1"
                            ? this.$const.getXJBParam("sname") || "理财宝"
                            : "银行卡";
                    this.result.sellToText = sellToText;
                }
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + rs.msg;
            }
            if (isBookingRedeem) {
                this.result.msg =
                    "您的预约赎回申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            } else {
                this.result.msg =
                    "您的赎回申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            }
            this.buySuccess = true;
        },
        // 同意快速赎回协议
        signAgreement() {
            if (this.fundInfo.sell == "1") {
                if (this.checkbox) {
                    return true;
                }
                let protocol = "";
                this.protocolArr.forEach((item) => {
                    protocol += `《${item.title}》`;
                });
                this.$confirm(`您还没有签署${protocol}，是否同意签署？`, {
                    confirmButtonText: "同意",
                    cancelButtonText: "不同意",
                    type: "warning"
                }).then(() => {
                    this.tracesLog(protocol);
                    this.checkbox = true;
                    return true;
                });
            } else {
                return true;
            }
        },
        // 留痕同意快速赎回协议
        tracesLog(protocol) {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.quick_redemption_agreement,
                eventname: `同意快速赎回协议`,
                content: JSON.stringify({ name: protocol })
            });
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.usableremainshare) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
            this.selectedFractionOption = "all";
        },
        fractionSell(denominator) {
            const availableShare = Number(this.bankInfo && this.bankInfo.usableremainshare);
            const denom = Number(denominator);
            if (!availableShare || !Number.isFinite(denom) || denom <= 0) {
                return;
            }
            const amount = Number((availableShare / denom).toFixed(2));
            this.$set(this.fundInfo, "amount", amount ? amount + "" : "0");
            this.$refs.fundInfo.validateField("amount");
            this.selectedFractionOption = denom;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.$set(this.fundInfo, "amount", _val);
            const vnum = Number(this.fundInfo.amount);
            const avail = Number(this.bankInfo && this.bankInfo.usableremainshare);
            if (vnum === avail) {
                this.isAmountAll = true;
                this.selectedFractionOption = "all";
            } else {
                this.isAmountAll = false;
                if (vnum === Number((avail / 2).toFixed(2))) {
                    this.selectedFractionOption = 2;
                } else if (vnum === Number((avail / 3).toFixed(2))) {
                    this.selectedFractionOption = 3;
                } else if (vnum === Number((avail / 4).toFixed(2))) {
                    this.selectedFractionOption = 4;
                } else {
                    this.selectedFractionOption = null;
                }
            }
            this.query = setTimeout(() => {
                this.queryRate();
            }, 500);
        },
        async getFundFeeRate() {
            let rs = await fundApi.qryFundFeeService({
                fundcode: this.fund.fundcode,
                feetype: "3", // 赎回费率
                invtp: "1",
                sharetype: this.fund.sharetype,
                discountedRateflag: "1"
            });
            if (rs.error) {
                return;
            }

            const list = rs.data;
            if (list.length > 0 && list[0].interval == " ") {
                this.fundFeeRate = [
                    {
                        interval: "固定费用",
                        feeRate: list[0].feerate
                    }
                ];
            } else {
                this.fundFeeRate = list.map((item) => {
                    return {
                        ...item,
                        value: this.extractNumber(item.feerate || "")
                    };
                });
            }

            // 查回的基金赎回费率为多条数据时，展示区间；否则直接展示执行费率即可
            if (this.fundFeeRate.length > 1) {
                const max = this.fundFeeRate.reduce((pre, cur) => {
                    return pre["value"] > cur["value"] ? pre : cur;
                });

                const min = this.fundFeeRate.reduce((pre, cur) => {
                    return pre["value"] < cur["value"] ? pre : cur;
                });

                this.rateMax = max["feerate"];
                this.rateMin = min["feerate"];
            }
        },
        extractNumber(str) {
            // 使用正则表达式匹配数字（包括整数、小数、正负号）
            const match = str.match(/-?\d+(\.\d+)?/);
            if (!match) {
                return null; // 没有找到有效的数字
            }
            // 提取数字部分并转换为数值
            let number = parseFloat(match[0]);
            // 检查是否包含百分号，如果有则除以100
            if (str.includes("%")) {
                number /= 100;
            }
            return number;
        },
        // 费率入参获取
        clearPenaltyRate() {
            this.penaltyRateData = null;
            this.penaltyRateTipData = null;
        },
        getPunitiveRateDays(data) {
            const apiDays = Number(data && data.punitiveratedays);
            if (Number.isFinite(apiDays) && apiDays > 0) {
                return apiDays;
            }
            const configDays = Number(this.$cache.getCompanyInfoParam("88202303"));
            if (Number.isFinite(configDays) && configDays > 0) {
                return configDays;
            }
            return 7;
        },
        getRangeHoldVol(item) {
            return Number((item && item.rangeholdvol) || 0);
        },
        getPenaltyRateValue(item) {
            const rate =
                item &&
                (item.rangefeerate || item.rangefeerate === 0
                    ? item.rangefeerate
                    : item.rangerfeerate || item.rangerfeerate === 0
                    ? item.rangerfeerate
                    : null);
            const rateNum = Number(rate);
            return Number.isFinite(rateNum) ? rateNum : null;
        },
        getPunitiveRate(dataList, punitiveRateDays) {
            const rateList = dataList
                .filter((item) => !this.isNonPunitiveRange(item, punitiveRateDays))
                .map((item) => this.getPenaltyRateValue(item))
                .filter((rate) => rate !== null);

            if (!rateList.length) {
                return null;
            }

            return Math.max.apply(null, rateList);
        },
        isNonPunitiveRange(item, punitiveRateDays) {
            const rangeDayMin = Number(item && item.rangedaymin);
            const rangeDayMax = Number(item && item.rangedaymax);

            // 优先按区间下限判断完整安全区间；部分接口数据可能只返回上限，
            // 因此也兼容 rangedaymax 已经超过惩罚天数边界的区间。
            return (
                (Number.isFinite(rangeDayMin) && rangeDayMin >= punitiveRateDays) ||
                (Number.isFinite(rangeDayMax) && rangeDayMax > punitiveRateDays)
            );
        },
        buildPenaltyRateTipData(data, applicationVol) {
            const dataList = Array.isArray(data && data.dataList) ? data.dataList : [];

            if (!dataList.length) {
                return null;
            }

            // 后端返回的是当前持仓按持有天数切分后的全部份额区间。
            // 惩罚性费率不能简单判断“是否存在小于 N 天区间”，因为赎回遵循先进先出：
            // 老份额会先被赎回，只有本次赎回份额超过老份额总量时，才会触及短期份额。
            const punitiveRateDays = this.getPunitiveRateDays(data);
            const punitiveRate = this.getPunitiveRate(dataList, punitiveRateDays);

            // FIFO：可先赎回的安全份额 = 所有不触发惩罚费率的区间份额合计。
            // 本次实际触发惩罚的份额 = 本次赎回份额 - 安全份额。
            const safeRedeemShare = dataList.reduce((total, item) => {
                return this.isNonPunitiveRange(item, punitiveRateDays)
                    ? total + this.getRangeHoldVol(item)
                    : total;
            }, 0);
            const punishShare = Math.max(Number(applicationVol || 0) - safeRedeemShare, 0);

            if (punishShare <= 0) {
                return null;
            }

            return Object.assign({}, data, {
                rangeholdvol: punishShare,
                punitiveratedays: punitiveRateDays,
                punitiveRate,
                punitiveRateText: punitiveRate === null ? "" : this.$util.fmtToPercent(punitiveRate)
            });
        },
        async queryPenaltyRate() {
            const querySeq = ++this.penaltyRateQuerySeq;

            if (
                !this.hasSelectedRedeemAccount() ||
                !this.isPenaltyRateOpen ||
                this.fund.redeemflag == "0" ||
                !Number(this.fundInfo.amount)
            ) {
                this.clearPenaltyRate();
                return;
            }

            try {
                const rs = await fundApi.combQueryHoldDayDetail({
                    fundcode: this.fund.fundcode,
                    transactionaccountid: this.bankInfo.transactionaccountid,
                    invtp: "1",
                    businesscode: "024",
                    applicationvol: this.fundInfo.amount
                });

                if (querySeq !== this.penaltyRateQuerySeq) return;
                this.penaltyRateData = (rs && rs.data) || null;
                this.penaltyRateTipData = this.buildPenaltyRateTipData(
                    this.penaltyRateData,
                    Number(this.fundInfo.amount)
                );
            } catch (e) {
                console.error("查询赎回惩罚性费率失败", e);
                if (querySeq === this.penaltyRateQuerySeq) {
                    this.clearPenaltyRate();
                }
            }
        },
        getPenaltyRateConfirmKey() {
            return [
                this.fund && this.fund.fundcode,
                this.fundInfo.id,
                this.fundInfo.sellTo,
                this.fundInfo.sell,
                this.fundInfo.amount,
                this.penaltyRateTipData && this.penaltyRateTipData.rangeholdvol,
                this.penaltyRateTipData && this.penaltyRateTipData.punitiveratedays,
                this.penaltyRateTipData && this.penaltyRateTipData.punitiveRate
            ].join("|");
        },
        async confirmPenaltyRateIfNeeded() {
            if (!this.hasPenaltyRateHoldingShare) {
                return true;
            }
            const confirmKey = this.getPenaltyRateConfirmKey();
            if (this.penaltyRateConfirmKey === confirmKey) {
                return true;
            }
            const punishShare = this.$util.fmtNum(this.penaltyRateTipData.rangeholdvol);
            const days = this.penaltyRateTipData.punitiveratedays;
            const punitiveRate = this.penaltyRateTipData.punitiveRateText || "1.50%";
            try {
                await this.$confirm(
                    `根据相关法律法规，对持有期少于${days}日的本基金份额，赎回时将收取不低于1.50%的赎回费。其中${punishShare}份份额持有天数小于${days}天，此部分将收取${punitiveRate}的惩罚性费率。`,
                    "惩罚性费率提示",
                    {
                        confirmButtonText: "继续赎回",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                );
                this.penaltyRateConfirmKey = confirmKey;
                return true;
            } catch (e) {
                return false;
            }
        },
        async queryRate() {
            const querySeq = ++this.sellFeeQuerySeq;
            if (!this.hasSelectedRedeemAccount()) {
                this.feeGate = {};
                this.clearPenaltyRate();
                return;
            }
            this.queryPenaltyRate();
            // 预约赎回和预约赎回转购不查手续费
            if (this.fund.redeemflag == "0") {
                this.clearPenaltyRate();
                return;
            }
            if (!Number(this.fundInfo.amount)) {
                this.feeGate = {};
                this.clearPenaltyRate();
                return;
            }
            if (this.isNormalXjbRedeem()) {
                await this.queryNormalXjbRedeemRate(querySeq);
                return;
            }
            this.$util.getFee(
                {
                    transactionaccountid: this.bankInfo.transactionaccountid,
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    businesscode: "24",
                    // paymode: "2",
                    applicationvol: this.fundInfo.amount,
                    channelid: this.fundInfo.channelid
                },
                (res) => {
                    if (querySeq === this.sellFeeQuerySeq) {
                        this.feeGate = res;
                    }
                }
            );
        },
        getCachedIsRealtaXjb() {
            const cacheVal =
                sessionStorage.getItem("_isRealtaXjb") || localStorage.getItem("_isRealtaXjb");
            if (cacheVal === null || cacheVal === undefined || cacheVal === "") return null;
            try {
                return JSON.parse(cacheVal) === true;
            } catch (e) {
                return cacheVal === "true";
            }
        },
        isNormalXjbRedeem() {
            return this.fundInfo.sellTo === "1" && this.getCachedIsRealtaXjb() === false;
        },
        getXjbBuyBusinessCode() {
            return this.xjbFundInfo && this.xjbFundInfo.status === "1" ? "20" : "22";
        },
        normalizeTargetFundList(data) {
            if (Array.isArray(data)) return data;
            if (!data || typeof data !== "object") return [];
            if (Array.isArray(data.datalist)) return data.datalist;
            if (data.body && Array.isArray(data.body.datalist)) return data.body.datalist;
            return [];
        },
        getFundCodeFromTargetItem(item) {
            return String(
                item.fundcode ||
                    item.targetfundcode ||
                    item.productcode ||
                    item.prodcode ||
                    item.targetproductcode ||
                    item.targetprodcode ||
                    ""
            ).trim();
        },
        async hasXjbConvertRelation() {
            const sourceFundCode = String(this.fund.fundcode || "").trim();
            const targetFundCode = String(this.xjbfundcode || "").trim();
            const cacheKey = `${sourceFundCode}_${targetFundCode}`;
            if (Object.prototype.hasOwnProperty.call(this.xjbConvertRelationCache, cacheKey)) {
                return this.xjbConvertRelationCache[cacheKey];
            }
            if (this.xjbConvertRelationPending[cacheKey]) {
                return this.xjbConvertRelationPending[cacheKey];
            }

            const pending = fundApi
                .combQueryTargetFundList({ fundcode: sourceFundCode })
                .then((res) => {
                    const targetList = this.normalizeTargetFundList(res.data);
                    const hasRelation = targetList.some(
                        (item) => this.getFundCodeFromTargetItem(item) === targetFundCode
                    );
                    this.$set(this.xjbConvertRelationCache, cacheKey, hasRelation);
                    return hasRelation;
                })
                .finally(() => {
                    this.$delete(this.xjbConvertRelationPending, cacheKey);
                });

            this.$set(this.xjbConvertRelationPending, cacheKey, pending);
            return pending;
        },
        buildSellFeeParams({ fundcode, sharetype, businesscode }) {
            return {
                transactionaccountid: this.bankInfo.transactionaccountid,
                fundcode,
                sharetype,
                businesscode,
                applicationamount: this.fundInfo.amount,
                applicationvol: this.fundInfo.amount,
                channelid: this.fundInfo.channelid || this.bankInfo.channelid
            };
        },
        normalizeFeeResult(feeGate) {
            if (!feeGate) return {};
            const result = Object.assign({}, feeGate);
            if (this.$util.isEmpty(result.estimatedcost) && !this.$util.isEmpty(result.charge)) {
                result.estimatedcost = result.charge;
            }
            if (
                this.$util.isEmpty(result.estimatedcost) &&
                !this.$util.isEmpty(result.preconvercharge)
            ) {
                result.estimatedcost = result.preconvercharge;
            }
            return result;
        },
        getFeeCost(feeGate) {
            if (!feeGate) return 0;
            const cost = !this.$util.isEmpty(feeGate.estimatedcost)
                ? feeGate.estimatedcost
                : !this.$util.isEmpty(feeGate.charge)
                ? feeGate.charge
                : feeGate.preconvercharge;
            return Number(cost || 0);
        },
        mergeRedeemForBuyFee(buyFee, redeemFee) {
            const normalizedBuyFee = this.normalizeFeeResult(buyFee);
            const normalizedRedeemFee = this.normalizeFeeResult(redeemFee);
            return Object.assign({}, normalizedRedeemFee, {
                estimatedcost:
                    this.getFeeCost(normalizedBuyFee) + this.getFeeCost(normalizedRedeemFee),
                xjbBuyFeeGate: normalizedBuyFee,
                redeemFeeGate: normalizedRedeemFee
            });
        },
        async queryNormalXjbRedeemRate(querySeq) {
            const hasRelation = await this.hasXjbConvertRelation();
            if (querySeq !== this.sellFeeQuerySeq) return;

            if (hasRelation) {
                const convertRes = await fundApi.qryTransFee(
                    Object.assign(
                        this.buildSellFeeParams({
                            fundcode: this.fund.fundcode,
                            sharetype: this.fund.sharetype,
                            businesscode: "36"
                        }),
                        {
                            targetfundcode: this.xjbfundcode,
                            targetsharetype: this.xjbFundInfo.sharetype
                        }
                    )
                );
                if (querySeq === this.sellFeeQuerySeq) {
                    this.feeGate = this.normalizeFeeResult(convertRes.data);
                }
                return;
            }

            const buyRes = await fundApi.qryTransFee(
                this.buildSellFeeParams({
                    fundcode: this.xjbfundcode,
                    sharetype: this.xjbFundInfo.sharetype,
                    businesscode: this.getXjbBuyBusinessCode()
                })
            );
            const redeemRes = await fundApi.qryTransFee(
                this.buildSellFeeParams({
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    businesscode: "24"
                })
            );
            if (querySeq === this.sellFeeQuerySeq) {
                this.feeGate = this.mergeRedeemForBuyFee(buyRes.data, redeemRes.data);
            }
        },
        amountLimit(rule, value, callback) {
            if (value === this.bankInfo.usableremainshare) {
                return callback();
            }
            rule.mes = "赎回份额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 赎回前数据查询
        async getSellInfo() {
            let rs = await fundApi.qryBeforeRedeem({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (rs.error) {
                return;
            }
            this.redeemInfo = rs.data;
            if (this.fund.sharetype != "2") {
                this.$set(this.fundInfo, "sharetype", this.fund.sharetype);
            }
            const resolvedSellTo = this.resolveSellToByAvailability(this.fundInfo.sellTo, "3");
            if (resolvedSellTo !== this.fundInfo.sellTo) {
                this.$set(this.fundInfo, "sellTo", resolvedSellTo);
            }
            // 初始化默认账号时也走过滤后的列表，避免选中已被隐藏的渠道账号
            const defaultAccount = this.getDefaultRedeemAccount(
                resolvedSellTo || this.fundInfo.sellTo
            );
            if (!defaultAccount) {
                this.$set(this.fundInfo, "id", "");
                this.clearRedeemAccountState();
                return;
            }
            this.$set(
                this.fundInfo,
                "id",
                defaultAccount.transactionaccountid + defaultAccount.index
            );
            this.isOffline = this.isOfflineAccount(defaultAccount);
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                this.$util.getSdxProtocol(
                    {
                        fundcode: this.xjbfundcode,
                        fundshowtype: this.fund.fundshowtype,
                        proto: "sell"
                    },
                    (res) => {
                        this.xjbFundRisk = res;
                        // this.protocol = true;
                        this.sellFund(true);
                    }
                );
            }
        },
        // 跳转到资产详情页
        showDetail() {
            this.$router.push("/assetsDetail");
        },
        // 计算总份额
        calculateTotal() {
            // 使用 reduce 方法安全计算总和
            this.sourceflagAllotment = this.fund.fundArr
                .filter((item) => {
                    return item.sourceflag === "2";
                })
                .reduce((sum, item) => {
                    // 确保值存在且为数字类型
                    const value = parseFloat(item.usableremainshare) || 0;
                    return sum + value;
                }, 0);
        },
        goToTradeRecord() {
            if (this.fund.way == "25") {
                this.$router.push({
                    name: "traderecord",
                    query: { activeType: "redemptionRecord" }
                });
            } else {
                this.$router.push({ name: "traderecord" });
            }
        }
    }
};
</script>
<style lang="scss">
.common-question-contain {
    margin-top: 41px;
    padding: 0 20px;
}
// 用类名bizcomp-sell-fund包一下，防止此处的bank-img-sel样式影响其它页面，比如新增银行卡页面的所属银行项
.bizcomp-sell-fund {
    .bank-img-sel {
        width: 550px !important;
    }
}

.center {
    text-align: center;
}

.redemp-btn-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}
.ratio-chip {
    display: inline-block;
    padding: 3px 10px;
    background: #f6f6f6;
    color: #999;
    border-radius: 3px;
    border: 1px solid #e1e1e1;
    cursor: pointer;
    line-height: 14px;
}
// .ratio-chip:hover {
//     border-color: var(--color-primary);
//     color: var(--color-primary);
//     background: #fff5f5;
// }
.ratio-chip.active {
    background: #fcf1f2;
    border-radius: 3px;
    color: #f35549;
    border: 1px solid #e1e1e1;
}
.sell-to-info {
    color: var(--color-primary);
    font-size: 14px;
    line-height: 30px;
    display: block;
    padding: 0 0 8px;
}
</style>

<style lang="scss" scope>
.sourceflag-tip {
    display: flex;
    align-items: center;
    .allotment {
        color: var(--color-primary);
    }
    .toDetails {
        cursor: pointer;
        color: var(--color-redirect);
    }
}

// 可用份额-冻结份额-旁边疑问号样式
.el-icon-question-diy {
    color: var(--color-text-accent);
    font-size: 18px;
    margin-left: 8px;
}

.text-gray {
    color: var(--color-text-regular);
    font-weight: 400;
    font-size: 14px;
}

.text-desc {
    color: var(--color-text-accent);
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
}

.left-5 {
    margin-left: 5px;
}

.dialog-box {
    margin: 20px 0;
    padding: 0 45px;
    display: flex;
    flex-direction: column;
    color: var(--color-text-primary);

    .rate-table {
        color: var(--color-text-primary);
        margin-top: 12px;
    }
    .btn {
        margin-top: 18px;
        width: 160px;
        height: 42px;
        background: var(--color-primary);
        font-size: 16px;
        color: var(--color-text-white);
    }
}

/* 协议勾选框统一样式 */
.protocol-checkbox-group {
    display: flex;
    align-items: flex-start;
    font-size: 14px;

    .protocol-checkbox-label {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 40px;

        input[type="checkbox"] {
            width: 18px;
            height: 18px;
            margin: 0;
            cursor: pointer;
        }

        span {
            padding-left: 5px;
            color: red;
        }
    }

    .protocol-file-list,
    ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            line-height: 40px;

            a.file-content,
            a {
                color: var(--color-redirect);
                text-decoration: none;
                cursor: pointer;

                &:hover {
                    color: var(--color-primary);
                }
            }
        }
    }
}
</style>
